import { NgModule } from '@angular/core';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import { SharedModule } from '../shared.module';
import { GeoRegionSelectorComponent } from './geo-region-selector.component';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        MatFormFieldModule,
        MatSelectModule,
    ],
    declarations: [GeoRegionSelectorComponent],
    exports: [GeoRegionSelectorComponent],
})
export class GeoRegionSelectorModule
{
}
